import { styles } from "./QuotationCard.style";
import * as moment from "moment";
import * as React from "react";
import { chain } from "lodash";

import RefreshIcon from "../Icons/RefreshIcon";

import ShieldIcon from "../Icons/ShieldIcon";
import { User } from "../../models/User.model";
import { Customer } from "../../types/Customer";
import { Quotation } from "../../types/Quotation";
import {
    Card,
    Typography,
    CardContent,
    CardActions,
    WithStyles,
    withStyles,
} from "../../../node_modules/@material-ui/core";
import { getProductTitle } from "../../helper/functions.helper";
import QuotationActions from "../QuotationActions/QuotationActions";
import { ActionHistory } from "../../types/ActionHistory";

interface QuotationCardProps extends WithStyles<typeof styles> {
    advisor: User;
    customer: Customer;
    quotation: Quotation;
    onActionPerformed(quotation: Quotation, actionHistory: ActionHistory, );
}

class QuotationCard extends React.Component<QuotationCardProps> {

    public render() {
        const { classes, theme, advisor, customer, quotation } = this.props;

        const lastAction = chain(quotation.actionHistory)
        .last()
        .value();

        return (
            <div>
                <Card className={classes.card}>
                    <header className={classes.header}>
                        <Typography variant="headline" component="h3" className={classes.title}>
                            {customer.lastname.toUpperCase()} {customer.firstname}
                        </Typography>
                        <Typography variant="body1" component="h4" className={classes.date}>
                            {moment(quotation.creationDate).format(" Do MMMM YYYY - hh[h]mm")}
                        </Typography>
                    </header>
                    <CardContent>
                        <div className={classes.status}>
                            <ShieldIcon className={classes.icon} nativeColor={theme.palette.primary.main} />
                            <Typography variant="body2">
                                {getProductTitle(quotation.productName, quotation.productVariantName)}
                            </Typography>
                        </div>
                        {quotation.actionHistory &&
                            quotation.actionHistory[0] && (
                                <div className={classes.status}>
                                    <RefreshIcon className={classes.icon} nativeColor={theme.palette.primary.main} />
                                    <Typography variant="body1">
                                        {this.getLabelForAction(lastAction.action)} {this.getLabelForActionType(lastAction.type)} 
                                    </Typography>
                                </div>
                            )}
                    </CardContent>
                    <CardActions className={classes.actions}>
                        <QuotationActions
                            advisor={advisor}
                            customer={customer}
                            quotation={quotation}
                            buttonOnly={true}
                            onActionPerformed={this.props.onActionPerformed}
                        />
                    </CardActions>
                </Card>
            </div>
        );
    }

    private getLabelForActionType(type: string): string {
        switch (type) {
            case "proposition":
                return "la proposition";
            case "adhesion":
                return "l'adhésion";
            default:
                return "";
        }
    }

    private getLabelForAction(action: string): string {
        switch (action) {
            case "creation":
                return "Création de ";
            case "send":
                return "Envoi de ";
            case "download":
                return "Téléchargement de ";
            case "print":
                return "Impression de ";
            default:
                return "";
        }
    }
}

export default withStyles(styles, { withTheme: true })(QuotationCard);



// WEBPACK FOOTER //
// ./src/components/QuotationCard/QuotationCard.tsx